<db-a-type-hero-section
  *ngIf="!!showSquare"
  [logoTitle]="logoTitle"
  [generationFinished]="generationFinished"
  [generatedTexts]="generatedTexts"></db-a-type-hero-section>
<db-b-type-hero-section
  *ngIf="!showSquare"
  [logoTitle]="logoTitle"
  [generationFinished]="generationFinished"
  [generatedTexts]="generatedTexts">
</db-b-type-hero-section>

<div class="generating" *ngIf="!!showGeneratingDiv">
  <div>
    <img src="assets/images/icons/ai-generate-blue.svg" />
    <span>Generating<span class="dots ml3"><span>.</span><span>.</span><span>.</span></span></span>
  </div>
</div>

<div class="overlay" [class.active]="(builderInteractionsService.generatePrefilledSiteLoading | async)">
  <db-prefilled-generation-finalize
    *ngIf="(builderInteractionsService.generatePrefilledSiteLoading | async)"
    [user]="user"
    [uniqueId]="uniqueId"
    [website]="website"
    [isEcommerce]="isEcommerce">
  </db-prefilled-generation-finalize>
</div>
